import { useGetClient } from '../../common/utils/withTokenClient';

export const useServiceMapsApi = () => useGetClient('maps');
export const useDomainsApi = () => useGetClient('domains');
export const useOverAllApi = () => useGetClient('overall');
